var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAutoWidth = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.75 4.25H2.25v11.5h15.5zM2.25 3C1.56 3 1 3.56 1 4.25v11.5c0 .69.56 1.25 1.25 1.25h15.5c.69 0 1.25-.56 1.25-1.25V4.25C19 3.56 18.44 3 17.75 3zm3.259 7.625L7 12.116 6.116 13l-3-3 3-3L7 7.884 5.51 9.375H9v1.25zm5.491 0h3.491L13 12.116l.884.884 3-3-3-3-.884.884 1.491 1.491H11z",
  clipRule: "evenodd"
})));
export default SvgAutoWidth;